import user from "./modules/user";
import menu from "./modules/menu";
import appUrls from "./modules/app-urls";

export default { user, menu, appUrls };
